import { Box } from '@mui/material';
import React, { useContext } from 'react';

import { palette, spaces } from '../../../../assets/styles/themes/tokens';
import {
	AIAssistantDisplayMode,
	aiAssistantContext,
} from '../../../../state/AIAssistantContextProvider';
import useScreenSize from '../../../../utils/useScreenSize';
import { DEFAULT_HEADLINE_HEIGHT } from '../constants';

const AIAssistantContentHeadline: React.FC<{
	children?: React.ReactNode;
}> = ({ children }) => {
	const { isXsScreen, isSmScreen } = useScreenSize();
	const { displayMode } = useContext(aiAssistantContext);
	const isDialogMode = displayMode === AIAssistantDisplayMode.DIALOG;
	const isXsOrSmScreen = isXsScreen || isSmScreen;
	const backgroundColor =
		isXsOrSmScreen || isDialogMode ? undefined : palette.background.paperElevation2;
	const borderBottom =
		isXsOrSmScreen || isDialogMode ? `1px solid ${palette.primary.contrast}` : undefined;
	return children ? (
		<Box
			sx={{
				paddingY: spaces.xl,
				paddingX: spaces.md,
				borderBottom,
				backgroundColor,
				width: '100%',
				height: DEFAULT_HEADLINE_HEIGHT,
				display: 'flex',
				justifyContent: 'center',
			}}
		>
			{children}
		</Box>
	) : null;
};

export default AIAssistantContentHeadline;
